import { useTranslation } from 'next-i18next'
import { useSelector } from 'react-redux'
import { selectMe } from '../../features/auth/authReducer'
import { toast } from 'react-toastify'
import { useMutation } from '@apollo/client'
import { CREATE_LEAD } from '../../services/graphql/mutations/createLead'
import { useMemo, useState } from 'react'
import { useRouter } from 'next/router'
import Link from 'next/link'

export default function PluginAddToCartDemo ({ plugin }) {
  const router = useRouter()
  const me = useSelector(state => selectMe(state.auth))
  const { t } = useTranslation('plugins')
  const [currentDemo, setCurrentDemo] = useState('')
  const [createLead] = useMutation(CREATE_LEAD)
  const hasNonPublicDownloads = useMemo(
    () => plugin.demos.some(demo => !demo.is_public_download),
    [plugin.demos]
  )
  const getDemoDownloadsAsSelectOptions = useMemo(() => {
    const demos = [...plugin.demos].filter(demo => {
      if (demo.is_public_download) {
        return true
      }

      return !!me
    })

    return demos.map(demo => (
      <option
        key={demo.id}
        value={demo.id}
      >
        {demo.software}
      </option>
    ))
  })

  const handleDemoDownload = async () => {
    const demo = plugin.demos.find(demo => Number(demo.id) === Number(currentDemo))

    if (!demo.is_public_download) {
      await createDemoLead()
    }

    window.open(demo.url)
  }

  const createDemoLead = async () => {
    try {
      await createLead({
        variables: {
          input: {
            name: me.full_name,
            subject: plugin.name,
            subject_id: parseInt(plugin.id),
            email: me.email,
            description: '',
            company_id: plugin.company.id,
            user_id: me.id,
            ref_link: localStorage.getItem('ref') || null,
            type: 'DOWNLOAD'
          }
        }
      })
    } catch (e) {
      toast.error(t('detail.cart.form.error', { ns: 'plugins' }))
    }
  }

  return (
    <div className="col-12">
      {
        (getDemoDownloadsAsSelectOptions.length === 0 && hasNonPublicDownloads) && (
          <Link href={`/login?redirect=${encodeURIComponent('plugins/' + router.query.slug)}`}>
            <a className="btn btn-outline-primary w-100">
              { t('detail.cart.demo_login') }
            </a>
          </Link>
        )
      }
      {
        getDemoDownloadsAsSelectOptions.length > 0 && (
          <div>
            <div>
              <label className="form-label">
                {
                  t('detail.cart.select_demo', { ns: 'plugins' })
                }
              </label>
              <select
                className="form-select"
                value={currentDemo}
                onChange={(e) => setCurrentDemo(e.target.value)}
              >
                <option value="">{t('select', { ns: 'common' })}</option>
                {getDemoDownloadsAsSelectOptions}
              </select>
            </div>
            <button
              className="btn btn-outline-primary w-100 mt-3"
              disabled={!currentDemo}
              type="button"
              onClick={handleDemoDownload}
            >
              {t('download', { ns: 'common' })}
            </button>
          </div>
        )
      }
    </div>
  )
}
